import https from "./https";
import store from "@/store";

const register = {
  register(params) {
    const organization = store.state.liffGeneral.orgCode;

    return https.post(`${organization}/liff/register/register`, params);
  },

  onlyVerify(params) {
    const organization = store.state.liffGeneral.orgCode;

    return https.post(`${organization}/liff/register/only-verify`, params);
  },

  verifyPhone(code) {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/general/phone/verify`, { code });
  },

  verifyByMobile(code, mobile_phone, shouldUpdateCustomerData = true) {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/general/phone/verify`, { code, mobile_phone, should_update_customer_data: shouldUpdateCustomerData });
  },

  sendPhone(mobile_phone) {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/general/phone/send`, { mobile_phone });
  },

  resendPhone() {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/general/phone/resend`);
  },

  getVerifyCodeExpiredTime(mobile_phone) {
    const organization = store.state.liffGeneral.orgCode;
    return https.get(
      `${organization}/liff/general/phone/verify-code-expired-time`,
      { params: { mobile_phone } }
    );
  },

  proceedRegistration(from = null) {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/register/proceed`, { from });
  },

  checkRegistered(params) {
    const organization = store.state.liffGeneral.orgCode;
    return https.get(`${organization}/liff/register/check-registered`, {
      params
    });
  },

  overwriteBinding(params) {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/register/overwrite-binding`, params);
  },

  getBranches(params) {
    const organization = store.state.liffGeneral.orgCode;
    return https.get(`${organization}/liff/branches`, {
      params
    });
  },

  getSingleBranch(branchId) {
    const organization = store.state.liffGeneral.orgCode;
    return https.get(`${organization}/liff/branches/${branchId}`);
  },

  unbind() {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/register/reset`);
  },

  cleanMobilePhone() {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/register/clean-mobile-phone`);
  },

  sendWelcomeMessage(params = {}) {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/register/send-welcome-message`, params);
  },

  checkTermCodeVersion() {
    const organization = store.state.liffGeneral.orgCode;
    return https.get(`${organization}/liff/register/check-term-code-version`);
  },

  saveTermConsent(params) {
    const organization = store.state.liffGeneral.orgCode;
    return https.post(`${organization}/liff/register/term-consent`, params);
  },
};

export default register;
